

<app-ui-card>

  <div class="nav">
    <div class="nav-header">
      <div class="nav-header__icon">
        <i class="pi pi-compass"></i>
      </div>
      <div class="nav-header__title">Навигация</div>
    </div>

    <div class="nav-item">
      <button
        type="button"
        pButton
        label="Главная"
        icon="pi pi-home"
        iconPos="left"
        [ngClass]="{'active': isActive('/')} "
        (click)="goTo('/')"
      ></button>
    </div>

    <div class="nav-item">
      <button
        type="button"
        pButton
        label="История платежей"
        icon="pi pi-credit-card"
        iconPos="left"
        [ngClass]="{'active': isActive('/payment-history')} "
        (click)="goTo('/payment-history')"
      ></button>
    </div>

    <div class="nav-item">
      <button
        type="button"
        pButton
        label="Трафик"
        icon="pi pi-chart-bar"
        iconPos="left"
        [ngClass]="{'active': isActive('/traffic')} "
        (click)="goTo('/traffic')"
      ></button>
    </div>

    <div class="nav-item">
      <button
        type="button"
        pButton
        label="Новости и события"
        icon="pi pi-megaphone"
        iconPos="left"
        [ngClass]="{'active': isActive('/news')}"
        (click)="goTo('/news')"
      ></button>
    </div>

    <div class="nav-item">
      <button
        type="button"
        pButton
        label="Заявления и документы"
        icon="pi pi-file"
        iconPos="left"
        [ngClass]="{'active': isActive('/statements')}"
        (click)="goTo('/statements')"
      ></button>
    </div>
  </div>
</app-ui-card>



<!--workaround for mobile resolutions-->
<p-panel
  [toggler]="'header'"
  [toggleable]="isMobile"
  [(collapsed)]="collapsed"
>
  <ng-template pTemplate="header">
    <div class="nav-header">
      <div class="nav-header__icon">
        <i class="pi pi-compass"></i>
      </div>
      <div class="nav-header__title">Навигация</div>
    </div>
  </ng-template>
  <div class="nav-item">
    <button
      type="button"
      pButton
      label="Главная"
      icon="pi pi-home"
      iconPos="left"
      [ngClass]="{'active': isActive('/')} "
      (click)="goTo('/')"
    ></button>
  </div>

  <div class="nav-item">
    <button
      type="button"
      pButton
      label="История платежей"
      icon="pi pi-credit-card"
      iconPos="left"
      [ngClass]="{'active': isActive('/payment-history')} "
      (click)="goTo('/payment-history')"
    ></button>
  </div>

  <div class="nav-item">
    <button
      type="button"
      pButton
      label="Трафик"
      icon="pi pi-chart-bar"
      iconPos="left"
      [ngClass]="{'active': isActive('/traffic')} "
      (click)="goTo('/traffic')"
    ></button>
  </div>

  <div class="nav-item">
    <button
      type="button"
      pButton
      label="Новости и события"
      icon="pi pi-megaphone"
      iconPos="left"
      [ngClass]="{'active': isActive('/news')}"
      (click)="goTo('/news')"
    ></button>
  </div>

  <div class="nav-item">
    <button
      type="button"
      pButton
      label="Заявления и документы"
      icon="pi pi-file"
      iconPos="left"
      [ngClass]="{'active': isActive('/statements')}"
      (click)="goTo('/statements')"
    ></button>
  </div>
</p-panel>
